import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faArrowLeft, faPowerOff } from "@fortawesome/free-solid-svg-icons";
import { logout } from "../../backend/login";
import { version } from "../../../package.json";

export default function() {
  const { children } = this.props;
  const { header, fullscreen = { id: 0 } } = this.state;

  return (
    <div className="container page">
      {!fullscreen && (
        <div className="page-header">
          <span onClick={this._back}>
            <FontAwesomeIcon icon={faArrowLeft} size="1x" />
          </span>
          {header}
          <small>v{version}</small>
          <span
            onClick={async () => {
              await logout();
              this._navigate("/login")();
            }}
          >
            <FontAwesomeIcon icon={faPowerOff} size="1x" />
          </span>
        </div>
      )}
      <div className="page-body">
        {!fullscreen && <div className="clear-fix-top" />}
        {children}
        {!fullscreen && <div className="clear-fix-bottom" />}
      </div>
      {/* {!fullscreen && (
        <div className="page-footer">
          <div className="icon" onClick={this._navigate("/machine")}>
            <FontAwesomeIcon size="2x" icon={faBarcode} />
            <span>Scan Machine</span>
          </div>
          <div className="icon" onClick={this._navigate("/machine/new")}>
            <FontAwesomeIcon size="2x" icon={faCar} />
            <span>Edit Machine</span>
          </div>
        </div>
      )} */}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/page/view.js